<template>
  <div :class="{ container: $feature.allowPasswordLogin }">
    <!-- espot: above-sign-up -->
    <cms-section v-if="eSpots?.['above-sign-up']" class="mt-6" lazy-media :section="eSpots?.['above-sign-up']" />
    <div class="mb-16 mt-6" :class="{ 'md:grid md:cols-2 divide-grey-50': $feature.allowPasswordLogin }">
      <div v-if="!$feature.allowPasswordLogin" class="my-8">
        <sign-in-simplified-enrollment @resolve="submit" />
        <!-- espot: below-sign-up -->
        <cms-section v-if="eSpots?.['below-sign-up']" lazy-media :section="eSpots?.['below-sign-up']" />
      </div>
      <template v-else>
        <form-sign-in
          class="lg:px-8 md:px-5 <md:pb-8"
          form-location="inline:body:sign-in:none"
          @submit="submit"
        />
        <div class="b-grey-60 space-y-5 <md:b-t <md:pt-8 md:b-l md:px-5 lg:px-8 lg:space-y-8">
          <form-sign-up
            v-if="$feature.allowNewSignUp"
            form-location="inline:body:sign-in:none"
            :simplified="$feature.allowSimplifiedEnrollment"
            @submit="submit"
          />
          <!-- espot: below-sign-up -->
          <cms-section v-if="eSpots?.['below-sign-up']" lazy-media :section="eSpots?.['below-sign-up']" />
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  middleware() {
    if (useAuthStore().loggedIn) return navigateTo('/account')
  }
})

const { $t, $feature } = useNuxtApp()
const { isSafe, redirect } = useSafeRedirect()
const redirectTo = useRouteQuery<string | undefined>('redirectTo')

const submit = () => {
  if (redirectTo.value && isSafe(redirectTo.value)) {
    redirect(redirectTo.value)
  }
  else {
    navigateTo($feature.enableLoyaltySignInRedirect ? '/account/loyalty' : '/account')
  }
}

useSeoMeta({ title: $t.registerOrSignIn })

// get espots
const { getSections } = useCms()
const eSpots = (await getSections.signUp()).data.value?.content.sectionsMap
</script>
